import $ from 'jquery';
import daterangepicker from 'daterangepicker';
jQuery(document).ready(function(){
    var format = "DD/MM/YYYY";
    jQuery('.m-field-date.is-multiple').daterangepicker({
        autoUpdateInput: false,
        autoApply: true,
        singleDatePicker:false,
        locale: {
            "format": format,
            /*"separator": objectL10n.separator,
            "applyLabel": objectL10n.applyLabel,
            "cancelLabel": objectL10n.cancelLabel,
            "fromLabel": objectL10n.fromLabel,
            "toLabel": objectL10n.toLabel,
            "customRangeLabel": objectL10n.customRangeLabel,
            "weekLabel": "S",
            "daysOfWeek": [
                objectL10n.dayShortDim,
                objectL10n.dayShortLun,
                objectL10n.dayShortMar,
                objectL10n.dayShortMer,
                objectL10n.dayShortJeu,
                objectL10n.dayShortVen,
                objectL10n.dayShortSam
            ],
            "monthNames": [
                objectL10n.monthLongJan,
                objectL10n.monthLongFev,
                objectL10n.monthLongMar,
                objectL10n.monthLongAvr,
                objectL10n.monthLongMai,
                objectL10n.monthLongJun,
                objectL10n.monthLongJui,
                objectL10n.monthLongAou,
                objectL10n.monthLongSep,
                objectL10n.monthLongOct,
                objectL10n.monthLongNov,
                objectL10n.monthLongDec
            ],
            "firstDay": 1,*/
        },
    }).on('apply.daterangepicker', function(ev, picker) {
        if (picker.startDate) {
            $(this).val(picker.startDate.format(format) + ' - ' + picker.endDate.format(format)).trigger('change');
        }
    });
    $('.m-field-date:not(.is-multiple)').daterangepicker({
        autoUpdateInput: false,
        autoApply: true,
        singleDatePicker:true,
        locale: {
            "format": format,
            /*"separator": objectL10n.separator,
            "applyLabel": objectL10n.applyLabel,
            "cancelLabel": objectL10n.cancelLabel,
            "fromLabel": objectL10n.fromLabel,
            "toLabel": objectL10n.toLabel,
            "customRangeLabel": objectL10n.customRangeLabel,
            "weekLabel": "S",
            "daysOfWeek": [
                objectL10n.dayShortDim,
                objectL10n.dayShortLun,
                objectL10n.dayShortMar,
                objectL10n.dayShortMer,
                objectL10n.dayShortJeu,
                objectL10n.dayShortVen,
                objectL10n.dayShortSam
            ],
            "monthNames": [
                objectL10n.monthLongJan,
                objectL10n.monthLongFev,
                objectL10n.monthLongMar,
                objectL10n.monthLongAvr,
                objectL10n.monthLongMai,
                objectL10n.monthLongJun,
                objectL10n.monthLongJui,
                objectL10n.monthLongAou,
                objectL10n.monthLongSep,
                objectL10n.monthLongOct,
                objectL10n.monthLongNov,
                objectL10n.monthLongDec
            ],
            "firstDay": 1,*/
        },
    }).on('apply.daterangepicker', function(ev, picker) {
        if (picker.startDate) {
            $(this).val(picker.startDate.format(format)).trigger('change');
        }
    });
})